import { render } from "./ConfigurationsVendors.vue?vue&type=template&id=18692a34"
import script from "./ConfigurationsVendors.vue?vue&type=script&lang=js"
export * from "./ConfigurationsVendors.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__